var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callout"},[_c('div',[_c('img',{attrs:{"src":_vm.image}})]),_c('h2',[_vm._t("default")],2),_c('div',[_c('router-link',{staticClass:"button-brand",attrs:{"to":_vm.link}},[_vm._v("\n            See List\n        ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }